// @flow
import { AsyncRequest } from 'angieslist-app-platform';
import { combineReducers } from 'redux';
import dealsActionKeys from './dealsActionKeys';
import type { AsyncState, Coupon, Deal } from '../types';

export type DealsReducerState = {
  coupons: AsyncState<any, { coupons: Coupon[] }>,
  deals: AsyncState<any, { offers: Deal[] }>,
};

export default (combineReducers({
  coupons: AsyncRequest.createReducer(dealsActionKeys.GET_COUPONS),
  deals: AsyncRequest.createReducer(dealsActionKeys.GET_DEALS),
}): any);



// WEBPACK FOOTER //
// ./src/modules/store/common/dealsReducer.js